// extracted by mini-css-extract-plugin
module.exports = {"rating":"TrustPilotRating_rating__Ppq5l","progress":"TrustPilotRating_progress__f1S77"};